import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ed4ddd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-4 py-lg-5 col-xl-7 px-2" }
const _hoisted_2 = { class: "text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "row mx-0 shadow bg-white p-3 p-lg-5 rounded-4" }
const _hoisted_4 = { class: "text-center fw-bold fs-6 lh-lg px-0 mb-0" }
const _hoisted_5 = { class: "text-center fw-bold fs-6 mb-3 lh-lg px-0" }
const _hoisted_6 = { class: "row mx-0 px-0 pb-4 gx-3 mb-2 justify-content-lg-center justify-content-start align-items-baseline border-bottom mb-4" }
const _hoisted_7 = { class: "w-max-content col-lg-2 col-form-label text-black" }
const _hoisted_8 = { class: "d-flex col-lg-5 pb-lg-0 pb-3" }
const _hoisted_9 = { class: "w-max-content me-4 col-form-label text-black" }
const _hoisted_10 = { class: "w-100" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "d-flex col-lg-5" }
const _hoisted_13 = { class: "w-max-content me-4 col-form-label text-black" }
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4 border-bottom" }
const _hoisted_17 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "d-flex justify-content-center my-3 my-lg-5" }

import Button from '@/components/button/index.vue'
import ErrorMessage from '@/components/error-message'
import { useRouter } from 'vue-router'
import { translate } from '@/languages/i18n'
import { ID } from './languages/ID'
import { computed, ref, onMounted } from 'vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'
import { customMaxLength } from '@/utils'

//constant
import { DEFAULT_MAX_JP_TEXT, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import alumnusServices from '@/services/alumnus-profile.services'
import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'

import TokenExpired from '@/components/token-expired/index.vue'
import { useRoute } from 'vue-router'
import ModalConfirm from '@/components/modal/ModalConfirmForgotPassword.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast()
const route = useRoute()
const modalConfirm = ref()

onMounted(() => {
  if (route.query?.token_expired)
    toast.error({
      component: TokenExpired,
    })
})
//TODO: SC50

const rules = computed(() => {
  return {
    family_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    given_name: {
      required,
      maxLength: (value: string) => customMaxLength(value, DEFAULT_MAX_JP_TEXT),
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
    email: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      minLength: minLength(MIN_LENGTH_EMAIL),
      email,
      pictograms: function (value) {
        return REGEX_EMOJI.test(value)
      },
    },
  }
})

const formData = ref({
  family_name: '',
  given_name: '',
  email: '',
})

const v$ = useVuelidate(rules, formData)

const router = useRouter()
const errorForgot = ref<boolean>(false)
const loadingSubmit = ref<boolean>(false)

const submitForm = () => {
  v$.value.$touch()
  if (v$.value.$invalid) return
  modalConfirm.value.toogleConfirmModal('show')
}

const onSubmit = async (): void => {
  loadingSubmit.value = true
  try {
    const response = await alumnusServices.alumnusForgotPassword({
      family_name: v$.value.family_name.$model,
      given_name: v$.value.given_name.$model,
      email: v$.value.email.$model,
    })

    if (response.status === 200) {
      errorForgot.value = false
      router.push('/alumni/forgot_password_mailed')
    } else {
      errorForgot.value = true
    }
  } catch (error) {
    console.log('err', error.response)
    errorForgot.value = true
  } finally {
    loadingSubmit.value = false
    modalConfirm.value.toogleConfirmModal('hide')
  }
}
const fullName = computed(() => `${v$.value.family_name.$model} ${v$.value.given_name.$model}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`${_unref(ID)}title`)), 1),
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)(`${_unref(ID)}heading1`)), 1),
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(translate)(`${_unref(ID)}heading2`)), 1),
        (errorForgot.value)
          ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
              key: 0,
              title: _unref(translate)(`${_unref(ID)}errorForgotPassword`)
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)(`nameKanji`)), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)(`surName`)), 1),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "family_name",
                class: _normalizeClass(['form-control', _unref(v$).family_name.$error ? 'is-invalid' : '']),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).family_name.$model) = $event)),
                placeholder: _unref(translate)('placeholder')
              }, null, 10, _hoisted_11), [
                [
                  _vModelText,
                  _unref(v$).family_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: 'surName',
                params: [1, 20],
                validator: _unref(v$).family_name.$errors[0]?.$validator
              }, null, 8, ["validator"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)(`name`)), 1),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                name: "given_name",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).given_name.$model) = $event)),
                class: _normalizeClass(['form-control', _unref(v$).given_name.$error ? 'is-invalid' : '']),
                placeholder: _unref(translate)('placeholder')
              }, null, 10, _hoisted_15), [
                [
                  _vModelText,
                  _unref(v$).given_name.$model,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createVNode(InputErrorMessage, {
                title: 'name',
                params: [1, 20],
                validator: _unref(v$).given_name.$errors[0]?.$validator
              }, null, 8, ["validator"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(translate)(`email`)), 1),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              class: _normalizeClass(["form-control", ['form-control', _unref(v$).email.$error ? 'is-invalid' : '']]),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).email.$model) = $event)),
              placeholder: "sample@yelloop.jp"
            }, null, 2), [
              [
                _vModelText,
                _unref(v$).email.$model,
                void 0,
                { trim: true }
              ]
            ]),
            _createVNode(InputErrorMessage, {
              title: 'email',
              params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
              validator: _unref(v$).email.$errors[0]?.$validator
            }, null, 8, ["params", "validator"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(Button, {
          title: _unref(translate)('SC50submitReset'),
          className: 'fw-bold',
          type: 'secondary',
          htmlType: 'button',
          onClick: submitForm
        }, null, 8, ["title"])
      ])
    ]),
    _createVNode(ModalConfirm, {
      onOnSubmit: onSubmit,
      ref: (_value, _refs) => {
        _refs['modalConfirm'] = _value
        modalConfirm.value = _value
      },
      email: (_unref(v$).email.$model as string),
      name: _unref(fullName)
    }, null, 8, ["email", "name"])
  ]))
}
}

})